/**
 * useIntercomAdapter — l'état du messager Intercom → le bouton d'aide du header parent.
 *
 * Lit `state.intercom.ready` / `unreadCount`, comme le `HelpFAB` legacy. L'ouverture arrive en
 * argument (`onOpen`) : `useOpenIntercomChat` vit dans `@common`, que `ports/**` n'importe pas.
 * `onContactSupport` reste absent tant que le SDK n'est pas prêt — la garde du `HelpFAB` : un
 * bouton d'aide qui n'ouvre rien vaut moins qu'un bouton absent.
 */
import { useSelector } from "react-redux"

export type IntercomAdapterConfig = {
    /** L'ouverture du messager, descendue par le pont legacy (`useOpenIntercomChat()`). */
    onOpen?: () => void
}

export type IntercomAdapter = {
    /** Ouvre la messagerie — absent tant que le SDK n'est pas identifié. */
    onContactSupport?: () => void
    /** Réponses du support non lues. */
    unreadCount: number
}

export function useIntercomAdapter(config: IntercomAdapterConfig = {}): IntercomAdapter {
    const { onOpen } = config

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ready = useSelector((state: any) => !!state?.intercom?.ready)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const unreadCount = useSelector((state: any) => (state?.intercom?.unreadCount as number) || 0)

    return { onContactSupport: ready ? onOpen : undefined, unreadCount }
}
